import styled from '@emotion/styled';
import React, { forwardRef } from 'react';
import { LargeText, } from '@polestar/component-warehouse-react/components/text/Text';
import { createCustomLineHeight } from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
import { createCustomSpacing } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const MarkingSystem = forwardRef(({ title, titleProps, subtitle, subtitleProps, ...props }, ref) => (React.createElement(Container, { ...props, ref: ref },
    React.createElement(LargeText, { ...titleProps, automatedAlignment: true }, title),
    React.createElement(StyledEmDash, null, "\u2014"),
    React.createElement(LargeText, { ...subtitleProps, automatedAlignment: true }, subtitle))));
MarkingSystem.displayName = 'MarkingSystem';
export default MarkingSystem;
const Container = styled.div `
  display: flex;
  flex-direction: column;
`;
const StyledEmDash = styled(LargeText) `
  line-height: ${createCustomLineHeight(26 / 16)};
  padding: 0;
  margin-inline-start: -${createCustomSpacing(2 / 16)};
`;
